import React from 'react';
import PropTypes from 'prop-types';
import LogoReverse from './LogoReverse';
import LogoReverseSmall from './LogoReverseSmall';
import LogoDefault from './LogoDefault';
import LogoSmall from './LogoSmall';
import LogoTaglineReverse from './LogoTaglineReverse';

const logos = {
  default: props => <LogoDefault {...props} />,
  small: props => <LogoSmall {...props} />,
  reverse: props => <LogoReverse {...props} />,
  reverseSmall: props => <LogoReverseSmall {...props} />,
  taglineReverse: props => <LogoTaglineReverse {...props} />,
};

const Logo = ({ type, ...props }) => logos[type](props);

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
};

Logo.defaultProps = {
  width: 134,
  height: 40,
  type: 'default',
};

export default Logo;
